<template>
  <p class="checkbox">
    <input type="checkbox" class="checkbox__input"
           :id="data.id"
           :name="data.id">
    <label class="checkbox__label" :for="data.id" tabindex="0">
      {{data.label}}
    </label>
  </p>
</template>

<script>
export default {
  name: 'Checkbox',
  props: {
    data: Object
  }
}
</script>

<style lang="scss">
  .checkbox {
    display: flex;
    margin: 0;

    &__input {
      display: none;

      &:focus {
        outline: 0;
        border-color: #554dbd;
      }

      :disabled {
        background-color: #f4f5f8;
      }

      &:checked ~ .checkbox__label:before {
        background: {
          color: #756dd4;
          image: url("/img/icons/icon-checkbox.svg");
          repeat: no-repeat;
          size: 14px 17px;
          position: 2px 1px;
        }
      }
    }

    &__label {
      position: relative;
      padding-left: 32px;
      font-size: 14px;
      line-height: 21px;
      color: #333333;

      &:active,
      &:focus {
        outline: 0;
      }

      &:before {
        position: absolute;
        content: '';
        width: 18px;
        height: 18px;
        top: 1px;
        left: 0;
        background-color: #e7e4f5;
        border-radius: 3px;
        transition: 200ms ease;
      }
    }
  }
</style>
